// modules
import { createAction } from 'redux-actions'

export const setIsAddReferralModalVisible = createAction(
  'SET_IS_ADD_REFERRAL_MODAL_VISIBLE'
)
